import { inferProjectToolType } from './projectToolType';

export function formatCreatedDate(value) {
  if (!value) return '';
  if (typeof value.toDate === 'function') {
    return value.toDate().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }
  if (typeof value === 'string') {
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    }
  }
  return '';
}

export function formatStatusLabel(status) {
  if (!status) return '';
  const s = String(status).trim();
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function isStatusCompleted(status) {
  return String(status || '')
    .trim()
    .toLowerCase() === 'completed';
}

export function buildProjectTitle(p) {
  const toolType = inferProjectToolType(p);
  if (toolType === 'floorplan_2d_to_3d') {
    return '2D Floor Plan to 3D';
  }
  const style = p?.style != null ? String(p.style).trim() : '';
  if (p?.designTool === 'building-exterior') {
    return style ? `${style} Exterior` : 'Exterior Renovation';
  }
  if (p?.designTool === 'garden-design' || toolType === 'garden_design') {
    return style ? `${style} Garden` : 'Garden Design';
  }
  const roomType = p?.roomType != null ? String(p.roomType).trim() : '';
  if (style && roomType) return `${style} ${roomType} Redesign`;
  return 'Room Redesign';
}

export function projectCanCompare(p) {
  return Boolean(p?.originalImageUrl && p?.generatedImageUrl);
}

/**
 * Source image for edit-mode workspace preview (upload / crop), not AI output.
 * Prefers the newest user-selected image over the stored project original.
 *
 * @param {{
 *   croppedPreviewUrl?: string;
 *   previewUrl?: string;
 *   preparedPreviewUrl?: string;
 *   project?: Record<string, unknown> | null;
 * }} params
 * @returns {string}
 */
export function resolveEditSourcePreviewUrl({
  croppedPreviewUrl = '',
  previewUrl = '',
  preparedPreviewUrl = '',
  project = null,
} = {}) {
  if (croppedPreviewUrl) return croppedPreviewUrl;
  if (previewUrl) return previewUrl;
  if (preparedPreviewUrl) return preparedPreviewUrl;
  const original = project?.originalImageUrl;
  return typeof original === 'string' && original.trim() ? original.trim() : '';
}

/**
 * Sidebar / viewer labels for original vs generated image toggles.
 * @param {Record<string, unknown> | null | undefined} project
 * @returns {{ original: string; redesigned: string }}
 */
export function getProjectResultViewLabels(project) {
  if (inferProjectToolType(project) === 'floorplan_2d_to_3d') {
    return { original: '2D Floor Plan', redesigned: '3D Floor Plan' };
  }
  const toolType = inferProjectToolType(project);
  if (toolType === 'building_exterior_design' || project?.designTool === 'building-exterior') {
    return { original: 'Original', redesigned: 'New Exterior' };
  }
  return { original: 'Original', redesigned: 'New Room' };
}
